const baseConfig = {
  urlPrefix: '',
  BASE_URL: '/api',
  docs: '/docs',
  email: 'support.us@medeli.com'
}

const config = {
  local: {
    ...baseConfig,
    environment: 'test',
    email: 'web_devil@sina.com'
  },
  test: {
    ...baseConfig,
    environment: 'test',
  }
}

export default config[process.env.REACT_APP_ENV] || config.test  as typeof config.local
